<script>
  import { isValidEmail } from "@lib/utils"
  import { CircleCheck, CircleX } from "lucide-svelte";
  
  let { value = $bindable(""), showError = true, ...props } = $props()

  let valid = $state(false)
  let invalid = $derived(!valid && value.length > 0)

  $effect(() => {
    valid = isValidEmail(value)
  })
</script>

<div class="input-container items-center border border-gray-200 relative focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500">
  <input type="email" bind:value {...props} class:border-red-500={invalid} />

  {#if invalid}
    <CircleX class="text-red-600 absolute right-2" size={14} strokeWidth={1.5} />
  {:else if valid}
    <CircleCheck class="text-green-600 absolute right-2" size={14} strokeWidth={1.5} />
  {/if}
</div>